import * as React from 'react'
import { SVGProps } from 'react'

const SvgSetupIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M1.205 13.5a2.25 2.25 0 0 0 3.073.826l.002-.001.334-.193c.63.54 1.354.957 2.136 1.233v.385a2.25 2.25 0 0 0 4.5 0v-.385a6.731 6.731 0 0 0 2.136-1.234l.336.193a2.251 2.251 0 1 0 2.25-3.9l-.333-.192c.15-.815.15-1.652 0-2.467l.333-.192a2.251 2.251 0 0 0-2.25-3.9l-.334.192a6.733 6.733 0 0 0-2.138-1.23V2.25a2.25 2.25 0 1 0-4.5 0v.385a6.732 6.732 0 0 0-2.136 1.234l-.335-.194a2.251 2.251 0 1 0-2.25 3.9l.333.192a6.826 6.826 0 0 0 0 2.468l-.333.192a2.254 2.254 0 0 0-.824 3.073ZM9 6a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z'
      fill='#fff'
    />
  </svg>
)

export default SvgSetupIcon
